import Vue from 'vue'
import Vuex from 'vuex'
import config from '@/config'

import {OneSignalInit, setExternalUserId, setSMSNumber} from '@/plugins/pushMessenging';

Vue.use(Vuex)
let timer
const STORAGE_KEY = 'orderio_config'
const STORAGE_DEFAULT = {
        modus: 'live',
        now: new Date(),
        config: {
          lang: 'nl',
          dark: false, 
          onboarding: [], 
          tabs:0,
          model: "favorite",
          type: 'deliver',
          address: null,
          paymenttype: 'ideal',
          description: null
        },
        token: Vue.prototype.$token,
        code: null,
        phone: null,
        user: null,
        hub: null,
        host: null,
        club: null,
        clubs: [],
        orders: [],
        cart: [],
        products: [],
        deliveries: []
      }
const state = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || JSON.stringify(STORAGE_DEFAULT))
const getters = {
  modus: state => {
    return state.modus
  },
  test: state => {
    return state.modus == 'test'
  },
  live: state => {
    return state.modus !== 'test'
  },
  now: state => {
    return state.now
  },
  token: state => {
    return state.token
  },
  code: state => state.code,
  courier: state => state.user ? state.user.courier : false,
  isFetch (state) {
    if (!state.user['#HOSTS']) return false
    return state.user['#HOSTS'].filter(h=>h._role=='DELIVERS').length>0
  },
  deliver: state => {
    return state.config.type == "deliver"
  },
  authenticated: state =>{
    if (!state.token) return false
    if (!state.user) return false
    if (!state.user._id) return false
    return true
  },
  config: state => {
    return state.config
  },
  dark: state => {
    return state.config.dark
  },
  payment: state =>{
    return {type: state.config.paymenttype || 'ideal', paid: false, status: 'open'}
  },
  getPhone: state => {
    return state.phone
  },
  user: state => {
    return state.user
  },
  cart: state => {
    return state.cart
  },
  hub: state => {
    return state.hub
  },
  host: state => {
    return state.host
  },
  club: state => {
    return state.club
  },
  orders: state => {
    return state.orders
  },
  products: state => {
    return state.products || []
  },
  getProducts: state => {
    return state.products || []
  },
  deliveries: state => {
    return state.deliveries || []
  },
  getDeliveries: state => {
    return state.deliveries || []
  },
  credits: state => {
    let credit = 0
    state.orders.filter(o=>o._host._id == 'organisation/bestelinfo' || o.stamps < 0).map(o=>credit+=o.stamps)
    if (credit<0) return 0
    return credit || 0
  },
  address: state => {
    return state.config.address
  },
  clubs: state => {
    return state.clubs
  },
  cartCount: state => {
    let count = 0
    state.cart.map(c=>count += c.$quantity)
    return count
  },
  cartAmount: (state,getters) => {
    return (state.config.type == 'deliver') ? getters.deliverAmount : getters.takeawayAmount
    let amount = 0
    state.cart.map(c=>amount += c.$amount)
    return amount
  },
  discountlist: (state) => {
    var d = new Date();
    var today = d.getDay();
    if (!state.host) return []
    return (state.host._discounts || []).filter(
      (d) =>
        (d.deliver == true || state.config.type != "deliver") &&
        (d.day == today || d.day == -1)
    );
  },
  discountNames: (state,getters) =>{
    return getters.discountlist.filter(d=>
    ((!d.tab && !d.group && d.percent) || d.quantity) 
    && ((getters.percentDiscountAmount > 0 && d.percent) ||
    (getters.quantumDiscountAmount > 0 && d.quantity))
    ).map(d=>d.name).join(', ')
  },
  quantumDiscountAmount:(state,getters)=>{
    var amount = 0
    getters.discountlist.filter(d=>d.quantity && d.pay).map(discount=>{
      amount += getDiscountAmount(discount, state)
    })
    return amount
  },
  percentDiscount:(state,getters)=>{
   let discounted = getters.discountlist.filter(d=>
    (getters.quantumDiscountAmount == 0 || !d.solo)
     && !d.tab && !d.group 
    && d.percent)[0] || {}
    return parseInt(discounted.percent || 0)
  },
 percentDiscountAmount: (state,getters)=>{
   return getters.cartAmount * getters.percentDiscount / 100
  },
 discountAmount: (state,getters)=>{
   return getters.quantumDiscountAmount + getters.percentDiscountAmount
 },
 deliveryAmount(state,getters){
  if (getters.cartCount == 0) return 0
  if (getters.address && state.config.type =='deliver') {
    if (getters.cartAmount<getters.address.min) return 'X' 
    if (getters.cartAmount<getters.address.max) return  getters.address.price
    return 0
  }
  return 0
},
deliveryCost(state,getters){
  if (getters.cartCount == 0) return 0
  if (getters.address) {
    if (getters.cartAmount<getters.address.min) return 0
    if (getters.cartAmount<getters.address.max) return  getters.address.price
    return 0
  }
  return 0
},
transactionAmount: (state,getters)=>{
  try {
    let payment = config.payment.filter(p=>p.value == state.config.paymenttype)[0] || {}
    return payment.price || 0
  }catch(e){
    return 0
  }
},
 totalAmount: (state,getters)=>{
   return getters.cartAmount - getters.discountAmount// + getters.transactionAmount
 },
  deliverAmount: state => {
    let amount = 0
    state.cart.map(c=>amount += (c.$quantity* ((c.$price_deliver ? c.$price_deliver: c.$price) + c.$subprice)))
    return amount
  },
  takeawayAmount: state => {
    let amount = 0
    state.cart.map(c=>amount += (c.$quantity* ((c.$price_takeout ? c.$price_takeout: c.$price) + c.$subprice)))
    return amount
  },
}

const mutations = {
  setNow: (state) => state.now = new Date(),
  setModus: (state, modus) => {
    state.modus = modus
  },
  resetState (state) {
    Vue.set(state, 'token', null) //Vue.prototype.$token
    Vue.set(state, 'user', null)
    Vue.set(state, 'hub', null)
    Vue.set(state, 'host', null)
    Vue.set(state, 'orders', [])
    Vue.set(state, 'deliveries', [])
    Vue.set(state, 'products', [])
    Vue.set(state, 'store',{})
    //Vue.set(state, 'phone',{})
    let c = Object.assign(state.config, config)
    c.address = null
    Vue.set(state, 'config', c)
    let phone = state.phone
    state = JSON.parse(JSON.stringify(STORAGE_DEFAULT))
    state.phone = phone
  },
  setConfig (state, config) {
    let c = Object.assign(state.config, config)
    Vue.set(state, 'config', c)
  },
  setToken (state, token) {
    token = token || Vue.prototype.$token
    Vue.prototype.$token = token
    Vue.set(state, 'token', token)
    setExternalUserId(token)
  },
  setCode (state, code) {
    Vue.set(state, 'code', code)
  },
  setPhone (state, phone) {
    Vue.set(state, 'phone', phone)
    if (phone) setSMSNumber(phone)
  },
  setUser (state, user) {
    Vue.set(state, 'user', user)
    if (user) setSMSNumber(user.phone)
  },
  setHub (state, hub) {
    Vue.set(state, 'hub', clean(hub))
  },
  setHost (state, host) {
    Vue.set(state, 'host', clean(host))
  },
  setClub (state, club) {
    Vue.set(state, 'club', clean(club))
  },
  setClubs (state, clubs) {
    Vue.set(state, 'clubs', clubs)
  },
  setOrders (state, orders) {
    Vue.set(state, 'orders', orders || [])
  },
  setProducts (state, products) {
    Vue.set(state, 'products', products || [])
  },
  setDeliveries (state, deliveries){
    Vue.set(state, 'deliveries', deliveries || [])
  },
  resetCart (state) {
    Vue.set(state, 'cart', [])
  },
  setCartItem (state, product) {
    if (!state.cart[product._cart-1]) return false
    state.cart.splice(product._cart-1, 1, product)
  },
  addCartItem (state, product) {
    if (!state.cart) Vue.set(state, 'cart', [])
    let item = state.cart.filter(i=> i.$name == product.$name && i.$subname == product.$subname)[0]
    if (item) {
      item.$quantity++
      item.$amount = item.$quantity*(item.$price+item.$subprice)
      return Vue.set(state, 'cart', state.cart.slice())
    }
    product.$quantity = product.$quantity || 1
    console.log(product)
    state.cart.push(product)
  },
  removeCartItem (state, product) {
    let item = state.cart.filter(i=> i.$name == product.$name && i.$subname == product.$subname)[0]
    if (item) item.$quantity--
    item.$amount = item.$quantity*(item.$price+item.$subprice)
    if (item && item.$quantity > 0) return Vue.set(state, 'cart', state.cart.slice())
     Vue.set(state, 'cart', state.cart.filter(i=> i.name !== product.name).slice())
  },
  updateCart (state) {
    state.cart.map(item=>{
      item.$price = ((state.config.type == 'deliver') ? item.$price_deliver : item.$price_takeout) || item.$price
      item.$amount = item.$quantity * (item.$price + item.$subprice)
    })
  },
  toggleFavoriteHub (state) {
    let hub = Object.assign({},state.hub,{_favorite: !state.hub._favorite})
    Vue.set(state, 'hub', hub)
  },
  toggleFavoriteHost (state) {
    let host = Object.assign({},state.host,{_favorite: !state.host._favorite})
    Vue.set(state, 'host', host)
  },
}

const actions = {
  setModus({ commit }, modus) {
    commit('setModus', modus)
  },
  startTimer({commit,state,dispatch}) {
    if (timer) return  false//clearInterval(timer)
    //console.log('start timer')
    commit('setNow')
    timer = window.setInterval(function(){
      commit('setNow')
    }, 60000);
  },
  login ({ commit }, {token,user}){
    if (!user) throw 'invalid user';
    if (!token) throw 'invalid token';
    OneSignalInit(token,user)
    commit('setToken', token)
    commit('setUser', user)
  },
  setCode({ commit }, code) {
    commit('setCode', code)
  },
  setPhone({ commit }, phone) {
    commit('setPhone', phone)
  },
  setUser({ commit }, user) {
    commit('setUser', user)
  },
  logout ({ commit }){
    commit('resetState')
  },
  setConfig ({ commit }, config) {
    commit('setConfig', config)
  },
  setHub ({ commit }, hub) {
    commit('setHub', hub)
  },
  setHost ({ commit }, host) {
    commit('setHost', host)
    const favicon = document.querySelector("link[rel~='icon']");
    if (!host || !host.logo) return favicon.href = './favicon.ico'
    favicon.href = host.logo.replace('.png','.ico').replace('.jpg','.ico').replace('/upload/','/upload/w_16,h_16,c_scale/');
  },
  setClub ({ commit }, club) {
    commit('setClub', club)
  },
  setClubs({ commit }, clubs) {
    commit('setClubs', clubs)
  },
  setOrders ({ commit }, orders) {
    commit('setOrders', orders)
  },
  setProducts({ commit }, products) {
    commit('setProducts', products)
  },
  setDeliveries({ commit }, deliveries) {
    commit('setDeliveries', deliveries)
  },
  resetCart ({ commit }) {
    commit('resetCart')
  },
  setCartItem ({ commit }, product) {
    commit('setCartItem', product)
  },
  addCartItem ({ commit }, product) {
    commit('addCartItem', product)
  },
  removeCartItem ({ commit }, product) {
    commit('removeCartItem', product)
  },
  updateCart ({ commit }) {
    commit('updateCart')
  },
  toggleFavoriteHub ({ commit }) {
    commit('toggleFavoriteHub')
  },
  toggleFavoriteHost ({ commit }) {
    commit('toggleFavoriteHost')
  },
}

function getDiscountAmount(discount,state){
  let amount = 0
     let items = []
     state.cart.filter(c=>c.tab == discount.tab || (discount.group && c.group == discount.group)).map(c=>{
        for(let i=0;i<c.$quantity;i++) items.push(c.$price + (c.$subprice||0))
      })
      items.sort((a, b) => a-b)
      let percent = 1
      if (discount.percent > 0) percent = discount.percent/100
      if (items.length >= discount.quantity){
        let dCount = items.length - Math.ceil(discount.pay*items.length/discount.quantity)
        if (dCount > 0) items.slice(0,dCount).map(i=>amount+=i*percent)
      }
   return amount
}

const plugins = [store => {
  store.subscribe((mutation, state) => {
    window.localStorage.setItem(STORAGE_KEY, stringify(state))
  })
}]

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  plugins
})
function stringify(obj, replacer, spaces, cycleReplacer) {
  return JSON.stringify(obj, serializer(replacer, cycleReplacer), spaces)
}

function serializer(replacer, cycleReplacer) {
  var stack = [], keys = []

  if (cycleReplacer == null) cycleReplacer = function(key, value) {
    if (stack[0] === value) return "[Circular ~]"
    return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]"
  }

  return function(key, value) {
    if (stack.length > 0) {
      var thisPos = stack.indexOf(this)
      ~thisPos ? stack.splice(thisPos + 1) : stack.push(this)
      ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key)
      if (~stack.indexOf(value)) value = cycleReplacer.call(this, key, value)
    }
    else stack.push(value)

    return replacer == null ? value : replacer.call(this, key, value)
  }
}

function clean(obj){
  return obj
}

